"use client";

import { c as _c } from "react/compiler-runtime";
import { CouponStatus } from "@sticker-giant/sg-frontend-common";
import { useCart } from "@/queries/useCart";
import { PromoCodeApplied } from "./PromoCodeApplied";
import { PromoCodeInput } from "./PromoCodeInput";
export function PromoCode() {
  const $ = _c(2);
  const {
    data: cart
  } = useCart();
  if (!cart) {
    return null;
  }
  if (cart.couponStatus === CouponStatus.APPLIED) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <PromoCodeApplied />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PromoCodeInput />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}